import type { Filter } from 'bad-words';
import { hasValue } from './general.helper';

let FilterClass: typeof Filter;

/**
 * Class representing a profanity filter that extends the functionality of the 'bad-words' filter.
 * @class ProfanityFilter
 * @extends Filter
 */
class ProfanityFilter {
  private filter: Filter;

  constructor() {
    // Initialize the filter lazily
    if (!FilterClass) {
      // Using require for CommonJS compatibility
      FilterClass = require('bad-words').Filter;
    }
    this.filter = new FilterClass();
  }

  /**
   * Cleans a string by replacing profane words with asterisks.
   * @method clean
   * @param {string} value - The string to clean.
   * @returns {string} The cleaned string.
   */
  public clean = (value: string): string => {
    if (!hasValue(value)) return value;
    try {
      return this.filter.clean(value);
    } catch (e) {
      const joinMatch = (this.filter as any).splitRegex.exec(value);
      const joinString = (joinMatch && joinMatch[0]) || '';
      return value
        .split((this.filter as any).splitRegex)
        .map((word: string) => {
          return (this.filter as any).isProfane(word) 
            ? (this.filter as any).replaceWord(word) 
            : word;
        })
        .join(joinString);
    }
  };

  /**
   * Checks if a string contains profane words.
   * @method isProfane
   * @param {string} value - The string to check.
   * @returns {boolean} True if the string contains profane words, false otherwise.
   */
  public isProfane = (value: string): boolean => {
    return this.filter.isProfane(value);
  };
}

export { ProfanityFilter };
